const optionsCache = {};

export default {
	data() {
		return {
			id: "",
			isMulti: false,
			loadings: {
				main: false,
			},
			totaloptions: [],
			dataModel: "",
			hasLoadData: false,
			query: "",
			filters: [],
			randId: "",
			searchHandler: null,
		};
	},
	computed: {
		myValue: {
			get: function() {
				if (this.value == null) {
					if (this.isMulti) {
						return [];
					} else {
						return {
							name: "",
							_id: "",
						};
					}
				}
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
		options() {
			if (!this.query) {
				this.query = "";
			}
			if (!this.filters) {
				this.filters = [];
			}

			let options = this.totaloptions.filter(
				function(item) {
					let _flag = false;
					if (this.filters && this.filters.length > 0) {
						for (let k in this.filters) {
							let _f = this.filters[k];
							if (_f.t == "_id" && item[_f.k]._id != _f.v) {
								return false;
							}
							if (_f.t == "string" && item[_f.k] != _f.v) {
								return false;
							}
							if (_f.t == "classify") {
								//这里 return true 表示没有分类的也出现，
								if (!item.classify) {
									return true;
								}
								_flag = item.classify.some(this_class => {
									return this_class._id == _f.v;
								});
								if (!_flag) {
									return false;
								}
							}
						}
					}
					if (!this.query) {
						this.query = "";
					}
					for (let k in this.nameFields) {
						_flag =
							item[this.nameFields[k]]
								.toLowerCase()
								.indexOf(this.query.toLowerCase()) > -1;
						if (_flag) {
							return _flag;
						}
					}
					return _flag;
				}.bind(this),
			);

			return options;
		},
	},
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
					_id: "",
				};
			},
		},
		filter: {
			type: Object,
			default() {
				return {
					field: "",
					value: "",
				};
			},
		},
		size: {
			type: String,
			default: "mini",
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name"];
			},
		},
		params: {
			type: Object,
			default: () => {
				return {
					allowCreate: true,
				};
			},
		},
	},
	created() {
		if (!this.randId) {
			this.randId = Math.random() + "";
			optionsCache[this.randId] = {};
		}

		console.log("created me!!!");
	},
	mounted() {
		console.log("RealteInput Created", this.dataModel);
		this.readOptions();
		if (!this.isMulti) {
			this.refreshData(this.value.name, true);
		} else {
			this.refreshData("", true);
		}
	},
	watch: {
		dataModel: {
			handler(val) {
				if (this.dataModel == "") {
					this.dataModel = this.dataModelName;
					this.readOptions();
				}
			},
			immediate: true,
		},
		"params.kvFilter": {
			handler() {
				this.refreshFilters();
			},
			immediate: true,
		},
		filter: {
			handler() {
				this.refreshFilters();
			},
			immediate: true,
		},
		"filters.length": {
			handler() {
				if (this.dataModel && this.filters.length > 0) {
					this.refreshData("", true);
				}
			},
			immediate: false,
			deep: true,
		},
		value: {
			handler(val) {
				if (this.dataModel == "") {
					this.dataModel = this.dataModelName;
					this.readOptions();
				}
				if (this.randId == "") {
					this.randId = Math.random() + "";
				}

				if (this.dataModel == "") {
					return;
				}
				if (!optionsCache[this.randId]) {
					optionsCache[this.randId] = {};
				}
				if (!optionsCache[this.randId][this.dataModel]) {
					optionsCache[this.randId][this.dataModel] = [];
				}
				//
				if (!this.isMulti) {
					if (!val._id) {
						this.id = "";
						return;
					}
					this.id = val._id;
					if (!optionsCache[this.randId][this.dataModel][val._id]) {
						optionsCache[this.randId][this.dataModel][val._id] = val;
						this.totaloptions.push(val);
					}
				} else {
					val.forEach(v => {
						if (v._id == "") {
							return;
						}
						if (!optionsCache[this.randId][this.dataModel][v._id]) {
							optionsCache[this.randId][this.dataModel][v._id] = v;
							this.totaloptions.push(v);
						}
					});
				}
			},
			immediate: true,
		},
	},
	methods: {
		readOptions() {
			console.log("readOptions", this.dataModel);
			if (this.dataModel == "" || this.randId == "") {
				return;
			}
			this.totaloptions = [];
			if (!optionsCache[this.randId][this.dataModel]) {
				optionsCache[this.randId][this.dataModel] = [];
				return;
			}
			for (let k in optionsCache[this.randId][this.dataModel]) {
				this.totaloptions.push(
					Object.assign({}, optionsCache[this.randId][this.dataModel][k]),
				);
			}
		},
		onCreated(newObj) {
			optionsCache[this.randId][this.dataModel][newObj._id] = newObj;
			this.totaloptions.push(newObj);
			this.myValue = JSON.parse(JSON.stringify(newObj));
		},
		refreshFilters() {
			this.filters = [];
			if (this.params.kvFilter) {
				this.params.kvFilter.forEach(valKV => {
					let index = this.filters.findIndex(val => {
						return val.k == valKV.k;
					});
					if (index > -1) {
						this.$set(this.filters, index, Object.assign({}, valKV));
					} else {
						this.filters.push(Object.assign({}, valKV));
					}
				});
			}
			if (this.filter.field == "" || !this.filter.value) {
				return;
			}
			let index = this.filters.findIndex(val => {
				return val.k == this.filter.field;
			});

			let realFilter = {};
			if (this.filter.field == "classify") {
				realFilter = {
					k: this.filter.field,
					t: "classify",
					v: this.filter.value[0]._id,
				};
			} else if (this.filter.type) {
				realFilter = {
					k: this.filter.field,
					t: this.filter.type,
					v: this.filter.value,
				};
			} else {
				realFilter = {
					k: this.filter.field,
					t: "_id",
					v: this.filter.value._id,
				};
			}
			if (index > -1) {
				this.$set(this.filters, index, realFilter);
			} else {
				this.filters.push(realFilter);
			}
		},
		refreshData(query, isImmediate = false) {
			if (this.dataModel == "") {
				return;
			}
			this.query = query;

			if (!query && this.hasLoadData && !isImmediate) {
				return;
			}

			if (!isImmediate) {
				if (this.searchHandler) {
					clearTimeout(this.searchHandler);
				}
				this.searchHandler = setTimeout(() => {
					this.refreshData(query, true);
					this.searchHandler = null;
				}, 500);
				return;
			}

			this.loadings.main = true;
			let params = { query };
			if (this.filters && this.filters.length > 0) {
				params.kvFilter = this.filters;
			}
			this.$axios
				.post("/curd/search/" + this.dataModel, params)
				.then(json => {
					this.loadings.main = false;

					let _flag = 0;
					for (let i = 0; i < json.data.datas.length; i++) {
						if (optionsCache[this.randId][this.dataModel][json.data.datas[i]._id]) {
							continue;
						}
						optionsCache[this.randId][this.dataModel][json.data.datas[i]._id] =
							json.data.datas[i];
						this.totaloptions.push(json.data.datas[i]);
					}

					this.hasLoadData = true;
				})
				.catch(json => {
					console.error(json);
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
			return [];
		},
		onCreateNew(val) {
			optionsCache[this.randId][this.dataModel][val._id] = val;
			this.totaloptions.push(Object.assign({}, val));
			this.query = "";
			this.$nextTick(() => {
				this.id = val._id;
				this.myValue = val;
			});
			this.refreshData("", true);
		},
		handleCreateNew(name) {
			this.loadings.main = true;

			this.$axios
				.post("/curd/do_quick_create/" + this.dataModel, {
					name: name,
				})
				.then(json => {
					this.loadings.main = false;
					this.$message({
						type: "success",
						message: "创建成功!",
					});
					this.onCreateNew(json.data.info);
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json);
				});
		},
		handleChange(val) {
			if (val) {
				let isNewCreated = true;
				for (let i = 0; i < this.options.length; i++) {
					if (
						(typeof val == "string" && val == this.options[i]._id) ||
						(val._id && val._id == this.options[i]._id)
					) {
						this.myValue = JSON.parse(JSON.stringify(this.options[i]));
						isNewCreated = false;
						break;
					}
				}
				if (isNewCreated && this.params.allowCreate) {
					this.$confirm("确认创建" + val + "?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(() => {
							this.handleCreateNew(val);
						})
						.catch(() => {
							this.id = "";
							this.$message({
								type: "info",
								message: "已取消",
							});
						});
				}
			} else {
				this.myValue = {
					name: "",
					_id: "",
					balance: 0,
				};
				this.refreshData("", true);
			}
		},
		calcName(item) {
			if (this.nameFields.length > 0) {
				let names = [];
				for (let k in this.nameFields) {
					names.push(item[this.nameFields[k]]);
				}
				return names.join(" / ");
			} else {
				return item[this.nameFields[0]];
			}
		},
	},
	components: {},
};
